/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateQuoteFromQuoteMutationVariables = Types.Exact<{
  input: Types.CreateQuoteFromQuoteInput;
}>;


export type CreateQuoteFromQuoteMutation = { createQuoteFromQuote: { __typename: 'CreateQuoteFromQuoteResult', quote: { __typename: 'Quote', id: string, createdFromQuoteId?: string | null } } };


export const CreateQuoteFromQuoteDocument = gql`
    mutation CreateQuoteFromQuote($input: CreateQuoteFromQuoteInput!) {
  createQuoteFromQuote(input: $input) {
    quote {
      id
      createdFromQuoteId
    }
  }
}
    `;
export type CreateQuoteFromQuoteMutationFn = Apollo.MutationFunction<CreateQuoteFromQuoteMutation, CreateQuoteFromQuoteMutationVariables>;

/**
 * __useCreateQuoteFromQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteFromQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteFromQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteFromQuoteMutation, { data, loading, error }] = useCreateQuoteFromQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteFromQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteFromQuoteMutation, CreateQuoteFromQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteFromQuoteMutation, CreateQuoteFromQuoteMutationVariables>(CreateQuoteFromQuoteDocument, options);
      }
export type CreateQuoteFromQuoteMutationHookResult = ReturnType<typeof useCreateQuoteFromQuoteMutation>;
export type CreateQuoteFromQuoteMutationResult = Apollo.MutationResult<CreateQuoteFromQuoteMutation>;
export type CreateQuoteFromQuoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteFromQuoteMutation, CreateQuoteFromQuoteMutationVariables>;